
<nav-bar></nav-bar>
<div class="page-details column scroller" id="pdfExport" *ngIf="fields" [class.isExporting]="isExporting">
  <w-validation-panel *ngIf="doc.api_failed" type="warning" details="{{'page_full.warning_latest_copy' | translate}}"></w-validation-panel>
  <div class="nameAndButtons flex space-between">
    <h1>{{ doc.applicationNumber }}</h1>
    <div class="buttons flex noprint" *ngIf="windowWidth > 800">
      <button w-button *ngIf="ss.searchResult.docs.length" (click)="backToResults()">
        <div class="ellipsis">{{ ("page_full.return_to_" + (ms.endpoint==="reports" ? "reports" : "results")) | translate }}</div>
      </button>
      <button w-button (click)="exportAsPDF()">{{ 'buttons.export_to_pdf' | translate }}</button>
      <button w-button *ngIf="!isNewTab" (click)="openNewTab()" style="margin-right:1ch">{{ 'page_full.open_new_tab' | translate }}</button>
      <div class="prevNext flex" *ngIf="ss.searchResult.hasPrev() || ss.searchResult.hasNext()">
        <button w-button [disabled]="!ss.searchResult.hasPrev()" title="{{ 'general_words.previous' | translate }}" (click)="prevDoc()">
          <div class="ellipsis">&larr;</div>
        </button><span class="nobreak" *ngIf="ss.searchResult.numFound > 0">{{ ss.searchResult.cursor | number }} / {{ ss.searchResult.numFound | number }}</span>
        <button w-button [disabled]="!ss.searchResult.hasNext()" title="{{ 'general_words.next' | translate }}" (click)="nextDoc()">
          <div class="ellipsis">&rarr;</div>
        </button>
      </div>
    </div>
  </div>
  <div class="infoAndStatus flex center-v">
    <!-- Status is on individual designs level-->
    <!-- img.status.noprint([src]=`'/assets/images/status/' + doc.gbdStatus + '.svg'`)-->
    <!-- {{ 'status.' + doc.gbdStatus | translate | uppercase }} // -->
    <h3> {{ doc.kind }} - {{ 'office.' + doc.registrationOfficeCode | translate }} ({{'designation.' + doc.registrationOfficeCode | translate}})	 </h3>
  </div>
  <div class="isMock" *ngIf="isMock">Notice : using mock data</div>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev2')"></altcha-widget>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev1')"></altcha-widget>
  <div class="textBlock">
    <ul class="columns">
      <li class="flex column col-50">
        <doc-field *ngIf="ev1" [field]="fields.applicationNumber"></doc-field>
        <doc-field *ngIf="ev2" [field]="fields.registrationNumber"></doc-field>
        <doc-field [field]="fields.subtype"></doc-field>
        <doc-field [field]="fields.registrationOfficeCode"></doc-field>
        <doc-field [field]="fields.designGrouping"></doc-field>
        <doc-field [field]="fields.designsCount"></doc-field>
      </li>
      <li class="flex column col-50">
        <doc-field [field]="fields.applicationDate"></doc-field>
        <doc-field [field]="fields.registrationDate"></doc-field>
        <doc-field [field]="fields.effectiveDate"></doc-field>
        <doc-field [field]="fields.expiryDate"></doc-field>
        <!--doc-field([field]="fields.publicationDate")-->
        <doc-field [field]="fields.classesLocarno"></doc-field>
        <doc-field [field]="fields.classesNational"></doc-field>
        <!--doc-field([field]="fields.productIndication")-->
      </li>
    </ul>
  </div>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev3')"></altcha-widget>
  <ul class="columns">
    <li class="column col-50">
      <h5 *ngIf="doc.isApplication">{{ 71 }} {{ 'inids.71' | translate | uppercase }}</h5>
      <h5 *ngIf="!doc.isApplication">{{ 73 }} {{ 'inids.73' | translate | uppercase }}</h5>
      <div class="textBlock" *ngFor="let item of fields.applicants; let last = last;">
        <doc-field [field]="item.fullName"></doc-field>
        <doc-field [field]="item.kind"></doc-field>
        <doc-field [field]="item.identifier"></doc-field>
        <doc-field [field]="item.fullAddress" *ngIf="item.fullAddress"></doc-field>
        <doc-field *ngIf="ev3" [field]="item.countryCode"></doc-field><br *ngIf="!last">
      </div>
    </li>
    <li class="column col-50" *ngIf="!doc.hasRepresentatives">
      <h5>{{ 74 }} {{ 'inids.74' | translate | uppercase }}</h5>
      <div class="textBlock"><span>-</span></div>
    </li>
    <li class="column col-50" *ngIf="doc.hasRepresentatives">
      <h5>{{ 74 }} {{ 'inids.74' | translate | uppercase }}</h5>
      <div class="textBlock" *ngFor="let item of fields.representatives; let last = last;">
        <doc-field [field]="item.fullName"></doc-field>
        <doc-field [field]="item.kind"></doc-field>
        <doc-field [field]="item.identifier"></doc-field>
        <doc-field [field]="item.fullAddress" *ngIf="item.fullAddress"></doc-field><br *ngIf="!last">
      </div>
    </li>
  </ul>
  <h3 class="expandable" *ngIf="fields.designs.length>1 && expandDesigns == false" (click)="toggleExpandDesigns()">{{ 'page_full.designs' | translate | uppercase }} ( + )</h3>
  <h3 class="expandable" *ngIf="fields.designs.length==1 && expandDesigns == false" (click)="toggleExpandDesigns()">{{ 'page_full.design' | translate | uppercase }} ( + )</h3>
  <h3 class="expandable" *ngIf="fields.designs.length>1 && expandDesigns == true" (click)="toggleExpandDesigns()">{{ 'page_full.designs' | translate | uppercase }} ( - )</h3>
  <h3 class="expandable" *ngIf="fields.designs.length==1 && expandDesigns == true" (click)="toggleExpandDesigns()">{{ 'page_full.design' | translate | uppercase }} ( - )</h3>
  <div class="textBlock" *ngFor="let d of fields.designs; index as i">
    <div class="designSingular">
      <ul class="columns" *ngIf="expandDesigns == true">
        <li class="flex column col-33">
          <doc-field [field]="d.publications"></doc-field>
          <doc-field [field]="d.applicationDate"></doc-field>
          <doc-field [field]="d.officeStatus"></doc-field>
          <doc-field [field]="d.gddStatus">       </doc-field>
          <doc-field [field]="d.statusDate"></doc-field>
        </li>
        <li class="flex column col-33">
          <doc-field [field]="d.noveltyStatement"></doc-field>
          <doc-field-array [field]="d.productIndicationClasses"></doc-field-array>
          <doc-field [field]="d.productIndication"></doc-field>
          <doc-field [field]="d.designDescription"></doc-field>
        </li>
        <li class="flex column col-33">
          <address-list [addresses]="d.designer" [inid]="72"></address-list>
        </li>
      </ul>
      <ul class="columns" *ngIf="expandDesigns == false">
        <li class="flex column col-33">
          <!-- - Doc field lined-->
          <doc-field-compact [field]="d.compact_date"> </doc-field-compact>
        </li>
        <li class="flex column col-33">
          <doc-field-compact [field]="d.compact_status">                </doc-field-compact>
        </li>
        <li class="flex column col-33">
          <doc-field-compact [field]="d.compact_text"> </doc-field-compact>
        </li>
      </ul><br>
      <ul class="flex logos" *ngIf="d.logos.content?.length > 0">
        <li class="flex" *ngFor="let img of d.logos.content;  let index = index">
          <div><span class="image" [tippy]="tippyTemplateDetails"><img [src]="images_blob_th[img]"></span><br><a class="noprint" (click)="findSimilarImages(get_th_image(img))">{{ 'page_full.find_similar_logos' | translate }}</a>
            <ng-template #tippyTemplateDetails>
              <div class="logoBig"><img src="{{images_blob_big[img]}}" alt=""></div>
            </ng-template>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <h3 *ngIf="doc.hasClassification">{{ 'general_words.classification' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev4')"></altcha-widget>
  <div class="textBlock classification" *ngIf="doc.hasClassification">
    <div class="block nationalClassification" *ngFor="let classifcation of fields.productIndicationClasses">
      <h4>{{ classifcation.code }} <span>{{ classifcation.label | translate | uppercase }}</span><span *ngIf="classifcation.version">- {{ classifcation.version | uppercase}}</span></h4>
      <ul class="columns" *ngIf="ev4">
        <li class="column col-100">
          <doc-field *ngFor="let terms of classifcation.content" [field]="terms"></doc-field>
        </li>
      </ul>
    </div>
  </div>
  <h3 *ngIf="(doc.priorities || doc.reference)">{{ 'page_full.priority_related' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev5')"></altcha-widget>
  <div class="textBlock related" *ngIf="(doc.priorities || doc.reference)">
    <ul class="columns">
      <li class="column" *ngIf="doc.priorities && ev5">
        <h4>{{ 30 }} {{ 'inids.30' | translate | uppercase }}</h4>
        <div *ngFor="let priority of fields.priorities; let last = last;">
          <doc-field [field]="priority.number" *ngIf="ev5"></doc-field>
          <doc-field [field]="priority.date"></doc-field>
          <doc-field [field]="priority.countryCode"></doc-field>
          <doc-field *ngIf="!priority.countryCode" [field]="priority.countryName"></doc-field>
          <doc-field [field]="priority.comment"></doc-field><br *ngIf="!last">
        </div>
      </li>
    </ul>
  </div>
  <h3>{{ 'general_words.office' | translate | uppercase }} - {{ ('office.' + doc.registrationOfficeCode) | translate }} ({{('designation.' + doc.registrationOfficeCode) | translate}})</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev6')"></altcha-widget>
  <div class="textBlock office">
    <ul class="columns">
      <li class="column col-33 logo">
        <div *ngIf="doc.link2office"><a [href]="doc.link2office" target="_blank"><img src="/assets/images/offices/{{ doc.registrationOfficeCode }}.png"></a></div>
        <div *ngIf="!doc.link2office"><img src="/assets/images/offices/{{ doc.registrationOfficeCode }}.png"></div>
      </li>
      <li class="column col-66">
        <doc-field [field]="fields.officeStatus"></doc-field>
        <doc-field [field]="fields.statusDate"></doc-field>
        <doc-field [field]="fields.designatedCountries" *ngIf="ev6"></doc-field>
      </li>
    </ul>
  </div>
  <div class="textBlock disclaimer">
    <p><span>{{'page_full.disclaimer' | translate}}</span><span class="noprint" *ngIf="doc.link2item"><a [href]="doc.link2item" target="_blank">{{'page_full.disclaimer_click' | translate}}</a></span></p>
  </div>
  <h3 *ngIf="(doc.filingPlace || doc.reference)">{{ 'page_full.general_info' | translate | uppercase }}</h3>
  <altcha-widget [challengeurl]="captchaURL" auto="onload" hidefooter="true" hidelogo="true" (verified)="onVerify($event, 'ev7')"></altcha-widget>
  <div class="textBlock" *ngIf="ev7 && (doc.filingPlace || doc.reference)">
    <ul class="columns">
      <li class="column col-50" *ngIf="(doc.filingPlace || doc.reference)">
        <doc-field [field]="fields.filingPlace"></doc-field>
      </li>
      <li class="column col-50" *ngIf="doc.reference">
        <h4>{{ 60 }} {{ 'inids.60' | translate | uppercase }}</h4>
        <doc-field [field]="fields.reference.office"></doc-field>
        <div *ngFor="let ref of fields.reference.application">
          <doc-field [field]="ref.number"></doc-field>
          <doc-field [field]="ref.date"></doc-field>
        </div>
        <div *ngFor="let ref of fields.reference.registration">
          <doc-field [field]="ref.number"></doc-field>
          <doc-field [field]="ref.date"></doc-field>
        </div>
      </li>
    </ul>
  </div>
</div>
